module.exports = __webpack_public_path__ + "static/media/Aktuelles_Teaser.f504692e.jpg";